import React from "react";
import FincludeLogo from "../../assets/images/Finclude Logo - Black.png";
import { Link } from "react-router-dom";

const ConfirmEmailPageLock = () => {
  return (
    <section id="wrapper">
      <div className="login-register">
        <div className="login-box card b-radius-20 shadow">
          <div className="card-body">
            <div className="col text-center">
              <img
                src={FincludeLogo}
                alt=""
                id="finclude-logo-"
                className="img-responsive pb-5"
                width="250"
                height="120"
              />
              <h5>An email has been sent to you. Please use the Activation Link to verify your email address.</h5>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ConfirmEmailPageLock;
